export const GET_INVESTMENT_OPTIONS = 'GET_INVESTMENT_OPTIONS';
export const GET_INVESTMENT_OPTIONS_SUCCESS = 'GET_INVESTMENT_OPTIONS_SUCCESS';
export const GET_INVESTMENT_OPTIONS_FAILURE = 'GET_INVESTMENT_OPTIONS_FAILURE';
export const SET_TRANSACTION_CONFIRMED_TRUE = 'SET_TRANSACTION_CONFIRMED_TRUE';
export const SET_CANCEL_CLICKED_TRUE = 'SET_CANCEL_CLICKED_TRUE';
export const SET_CANCEL_CLICKED_FALSE = 'SET_CANCEL_CLICKED_FALSE';
